import { defineStore } from 'pinia'
import { Session } from '../../../../lib/models/session'
import { StoreHelper } from '../../helpers/storeHelper'

export const useSessionStore = defineStore('session', {
  state: () => ({
    sessions: [] as any[],
    total: 0,
  }),
  actions: {
    async findAllSessions({ query, url }: { query?: any, url?: string } = {}) {
      if (!url) {
        url = StoreHelper.loadRootState('endpointSession').url
      }
      const { findAll } = StoreHelper.loadRootState()
      let arr = await findAll({ url }, query)
      if (arr && Array.isArray(arr.data)) {
        arr = arr.data
      }
      if (arr && Array.isArray(arr) && arr.length > 0) {
        const sessions = Session.initOnlyValidFromArray(arr || [])
        this.sessions = sessions
        this.total = sessions.length || 0
        return {
          sessions,
          total: sessions.length || 0
        }
      }
      throw StoreHelper.error(arr, 'No session found.')
    }
  }
})
